module.exports = "<div class=\"main\">\r\n    <div class=\"loader-wrapper\" *ngIf=\"isAppReady\">\r\n        <div class=\"loader\"></div>\r\n    </div>\r\n    <header class=\"navbar navbar-inner navbar-fixed-top\">\r\n    \t<app-header ></app-header>\r\n    </header>\r\n    <section class=\"app-container\">\r\n    \t<router-outlet></router-outlet>\r\n    </section>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/boot/app.component.html
// module id = 469
// module chunks = 0